document.addEventListener("DOMContentLoaded", function () {
    const sliderWrapper = document.querySelector(".recipe__grid-wrapper");
    // La sección del carousel no está en todas las páginas: sin esto, TypeError en consola.
    if (!sliderWrapper) return;
    const prevButton = document.querySelector(".arrows__wrapper .left__arrow");
    const nextButton = document.querySelector(".arrows__wrapper .right__arrow");
    const productCards = document.querySelectorAll(".recipe__grid-wrapper .recipe__item");

    let currentIndex = 0;
    const gap = parseInt(getComputedStyle(sliderWrapper).gap) || 20;

    function updateSlider() {
        const scrollAmount = productCards[0].offsetWidth + gap;
        sliderWrapper.scrollTo({
            left: currentIndex * scrollAmount,
            behavior: "smooth"
        });
    }

    // Initial state
    updateSlider();

    if (nextButton) {
        nextButton.addEventListener("click", function () {
            if (currentIndex < productCards.length - 1) {
                currentIndex++;
                updateSlider();
            }
        });
    }

    if (prevButton) {
        prevButton.addEventListener("click", function () {
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider();
            }
        });
    }

    // Update index on manual scroll
    sliderWrapper.addEventListener("scroll", function () {
        const scrollLeft = sliderWrapper.scrollLeft;
        const scrollAmount = productCards[0].offsetWidth + gap;
        currentIndex = Math.round(scrollLeft / scrollAmount);
    });
});
